/* file description */
import { useMemo } from 'react';
import { pageObj, BUTTONLIST } from '../consts';
import useMetaStore from '@/store/useMetaStore';

export const useStatusBtns = () => {
  const { pageType, taskInfo, pageConfig, utils, isMobile } = useMetaStore();

  const filterBtns = useMemo(() => {
    let resultArr = pageObj[pageType] || [];
    const pList =
      pageConfig.rulePageValue?.filter(
        (item: any) => item?.events?.isMakeBtn === true,
      ) || [];

    /**
     * 判断什么时候不需要关闭按钮
     * 1.手机端不需要 2.弹框的页面
     */
    const isModalpage =
      utils?.queryParams?.SHOWTYPE === 'modal' ||
      pageConfig?.createPageConfig?.hideClose;
    if (isMobile || isModalpage) {
      resultArr = resultArr.filter((item) => item !== 'close-btns');
    }

    if (pageType === 'view') {
      const detailBtns = (pageConfig?.detailPageConfig?.bottmBtns ||
        []) as string[];
      resultArr = [...resultArr, ...detailBtns];
    } else {
      const createBtns = (pageConfig?.createPageConfig?.bottmBtns ||
        []) as string[];
      resultArr = [...resultArr, ...createBtns];
    }

    if (pageType === 'add') {
      resultArr = resultArr?.filter((item) => item !== 'delete-btns');
    }

    // 判断规则里是否有流程按钮
    let processTag = false;
    pList.forEach((rule) => {
      if (
        rule.events?.btnConfig?.process &&
        rule.events?.btnConfig?.process?.['submit-btns'] === true
      ) {
        processTag = true;
      }
    });
    if (pageConfig?.createPageConfig?.hideSubmit) {
      processTag = true;
    }

    if (taskInfo.flag === 'true' && !processTag) {
      pageType !== 'view' && resultArr.push('submit-btns');
    }

    return resultArr;
  }, [pageType, pageConfig, taskInfo]);

  return {
    btnList: filterBtns,
  };
};
